import c1 from "../../about/resource/c1.jpg"
import c2 from "../../about/resource/c2.jpg"
import c3 from "../../about/resource/c3.jpg"
import c4 from "../../about/resource/c4.jpg"
import c5 from "../../about/resource/c5.jpg"
import c6 from "../../about/resource/c6.jpg"
import c7 from "../../about/resource/c7.jpg"

export const SliderData1=[
    {
        image:c1
    },
    {
        image:c2
    },
    {
        image:c3
    },
    {
        image:c4
    },
    {
        image:c5
    },
    {
        image:c6
    },
    {
        image:c7
    }
    
]